export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7065.fd79f135.jpg";